import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
const resources = {
  en: {
    translation: {      quiz: {
        title: 'DMV Practice Quiz',
        notFound: 'Quiz not found',
        previous: 'Previous',
        next: 'Next',
        finish: 'Finish Quiz',
        question: 'Question',
        score: 'Score',
        loading: 'Loading quiz...',
        complete: 'Quiz Complete!',
        yourScore: 'Your Score',
        tryAgain: 'Try Again',
        bookmark: 'Bookmark Question',
        remove: 'Remove Bookmark',
        of: 'of',
        answered: 'answered',
        questionsAnswered: 'questions answered',
        currentProgress: 'Current progress',
        previousQuestion: 'Go to previous question',
        nextQuestion: 'Go to next question'
      },
      navigation: {
        home: 'Home',
        practice: 'Practice Test',
        bookmarks: 'Bookmarks',
        settings: 'Settings'
      },      states: {
        ny: 'New York',
        ct: 'Connecticut'
      },
      offline: {
        title: "You're Offline",
        message: "It looks like you've lost your internet connection. Don't worry - you can still access your saved quizzes!",
        tryAgain: 'Try Again',
        tryAgainLabel: 'Try reconnecting to the internet',
        availableFeatures: {
          title: 'Available Offline',
          label: 'Offline available features',
          list: [
            'Saved quizzes',
            'Bookmarked questions',
            'Previous quiz results'
          ]
        }
      },
      about: {
        title: 'About DMV Quiz App',
        purpose: {
          title: 'Purpose',
          description: 'The DMV Quiz App helps you prepare for your driving test with practice questions from official DMV manuals. Available for New York and Connecticut.'
        },
        features: {
          title: 'Features',
          list: [
            'Study and test modes for effective learning',
            'Questions based on official DMV materials',
            'Available in English, Spanish, and Portuguese',
            'Track your progress and bookmark questions'
          ]
        },
        contact: {
          title: 'Contact',
          text: 'For support or feedback, please',
          emailLabel: 'Send email to support',
          emailText: 'contact us'
        }
      },
      bookmarks: {
        title: 'Bookmarked Questions',
        filters: 'Filters',
        state: 'State',
        filterByState: 'Filter questions by state',
        allStates: 'All States',
        questionsList: 'Bookmarked questions list',
        noQuestions: 'No bookmarked questions yet. Start a quiz to bookmark questions!'
      },
      settings: {
        title: 'Settings',
        quizPreferences: 'Quiz Preferences',
        showInstantFeedback: 'Show instant feedback in study mode',
        accessibility: 'Accessibility',
        highContrast: 'High contrast mode',
        fontSize: 'Font Size',
        selectFontSize: 'Select font size',
        fontSizes: {
          normal: 'Normal',
          large: 'Large',
          xlarge: 'Extra Large'
        },
        saveChanges: 'Save Changes'
      },
      home: {
        title: 'DMV Quiz App',
        subtitle: 'Your best resource to study and practice for the DMV theoretical exam. Choose a quiz below to get started!',
        startQuiz: 'Start Quiz',
        state: 'State',
        availableQuizzes: 'Available quizzes'
      }
    }
  },
  es: {
    translation: {      quiz: {
        title: 'Práctica de DMV',
        notFound: 'Cuestionario no encontrado',
        previous: 'Anterior',
        next: 'Siguiente',
        finish: 'Terminar',
        question: 'Pregunta',
        score: 'Puntuación',
        loading: 'Cargando cuestionario...',
        complete: '¡Cuestionario Completado!',
        yourScore: 'Tu Puntuación',
        tryAgain: 'Intentar de Nuevo',
        bookmark: 'Marcar Pregunta',
        remove: 'Quitar Marca',
        of: 'de',
        answered: 'respondidas',
        questionsAnswered: 'preguntas respondidas',
        currentProgress: 'Progreso actual',
        previousQuestion: 'Ir a la pregunta anterior',
        nextQuestion: 'Ir a la siguiente pregunta'
      },
      navigation: {
        home: 'Inicio',
        practice: 'Prueba de Práctica',
        bookmarks: 'Marcadores',
        settings: 'Configuración'
      },      states: {
        ny: 'Nueva York',
        ct: 'Connecticut'
      },
      offline: {
        title: 'Estás Desconectado',
        message: 'Parece que has perdido tu conexión a internet. ¡No te preocupes - aún puedes acceder a tus cuestionarios guardados!',
        tryAgain: 'Intentar de Nuevo',
        tryAgainLabel: 'Intentar reconectar a internet',
        availableFeatures: {
          title: 'Disponible Sin Conexión',
          label: 'Funciones disponibles sin conexión',
          list: [
            'Cuestionarios guardados',
            'Preguntas marcadas',
            'Resultados anteriores'
          ]
        }
      },
      about: {
        title: 'Sobre la Aplicación DMV Quiz',
        purpose: {
          title: 'Propósito',
          description: 'La aplicación DMV Quiz te ayuda a prepararte para tu examen de conducir con preguntas prácticas de los manuales oficiales del DMV. Disponible para Nueva York y Connecticut.'
        },
        features: {
          title: 'Características',
          list: [
            'Modos de estudio y examen para un aprendizaje efectivo',
            'Preguntas basadas en materiales oficiales del DMV',
            'Disponible en inglés, español y portugués',
            'Seguimiento de progreso y marcado de preguntas'
          ]
        },
        contact: {
          title: 'Contacto',
          text: 'Para soporte o comentarios, por favor',
          emailLabel: 'Enviar correo electrónico a soporte',
          emailText: 'contáctanos'
        }
      },
      bookmarks: {
        title: 'Preguntas Marcadas',
        filters: 'Filtros',
        state: 'Estado',
        filterByState: 'Filtrar preguntas por estado',
        allStates: 'Todos los Estados',
        questionsList: 'Lista de preguntas marcadas',
        noQuestions: '¡No hay preguntas marcadas aún. ¡Comienza un cuestionario para marcar preguntas!'
      },
      settings: {
        title: 'Configuración',
        quizPreferences: 'Preferencias del Cuestionario',
        showInstantFeedback: 'Mostrar retroalimentación inmediata en modo estudio',
        accessibility: 'Accesibilidad',
        highContrast: 'Modo de alto contraste',
        fontSize: 'Tamaño de Letra',
        selectFontSize: 'Seleccionar tamaño de letra',
        fontSizes: {
          normal: 'Normal',
          large: 'Grande',
          xlarge: 'Extra Grande'
        },
        saveChanges: 'Guardar Cambios'
      },
      home: {
        title: 'Aplicación de Prueba DMV',
        subtitle: 'Tu mejor recurso para estudiar y practicar para el examen teórico de DMV. ¡Elige una prueba para comenzar!',
        startQuiz: 'Comenzar Prueba',
        state: 'Estado',
        availableQuizzes: 'Pruebas disponibles'
      }
    }
  },
  pt: {
    translation: {      quiz: {
        title: 'Teste Prático de DMV',
        notFound: 'Questionário não encontrado',
        previous: 'Anterior',
        next: 'Próximo',
        finish: 'Finalizar',
        question: 'Questão',
        score: 'Pontuação',
        loading: 'Carregando questionário...',
        complete: 'Questionário Completo!',
        yourScore: 'Sua Pontuação',
        tryAgain: 'Tentar Novamente',
        bookmark: 'Marcar Questão',
        remove: 'Remover Marca',
        of: 'de',
        answered: 'respondidas',
        questionsAnswered: 'questões respondidas',
        currentProgress: 'Progresso atual',
        previousQuestion: 'Ir para questão anterior',
        nextQuestion: 'Ir para próxima questão'
      },
      navigation: {
        home: 'Início',
        practice: 'Teste Prático',
        bookmarks: 'Marcadores',
        settings: 'Configurações'
      },      states: {
        ny: 'Nova York',
        ct: 'Connecticut'
      },
      offline: {
        title: 'Você Está Offline',
        message: 'Parece que você perdeu sua conexão com a internet. Não se preocupe - você ainda pode acessar seus testes salvos!',
        tryAgain: 'Tentar Novamente',
        tryAgainLabel: 'Tentar reconectar à internet',
        availableFeatures: {
          title: 'Disponível Offline',
          label: 'Recursos disponíveis offline',
          list: [
            'Testes salvos',
            'Questões marcadas',
            'Resultados anteriores'
          ]
        }
      },
      about: {
        title: 'Sobre o Aplicativo DMV Quiz',
        purpose: {
          title: 'Objetivo',
          description: 'O aplicativo DMV Quiz ajuda você a se preparar para seu teste de direção com questões práticas dos manuais oficiais do DMV. Disponível para Nova York e Connecticut.'
        },
        features: {
          title: 'Recursos',
          list: [
            'Modos de estudo e teste para aprendizado efetivo',
            'Questões baseadas em materiais oficiais do DMV',
            'Disponível em inglês, espanhol e português',
            'Acompanhe seu progresso e marque questões'
          ]
        },
        contact: {
          title: 'Contato',
          text: 'Para suporte ou feedback, por favor',
          emailLabel: 'Enviar email para suporte',
          emailText: 'entre em contato'
        }
      },
      bookmarks: {
        title: 'Questões Marcadas',
        filters: 'Filtros',
        state: 'Estado',
        filterByState: 'Filtrar questões por estado',
        allStates: 'Todos os Estados',
        questionsList: 'Lista de questões marcadas',
        noQuestions: 'Nenhuma questão marcada ainda. Comece um teste para marcar questões!'
      },
      settings: {
        title: 'Configurações',
        quizPreferences: 'Preferências do Questionário',
        showInstantFeedback: 'Mostrar feedback imediato no modo estudo',
        accessibility: 'Acessibilidade',
        highContrast: 'Modo de alto contraste',
        fontSize: 'Tamanho da Fonte',
        selectFontSize: 'Selecionar tamanho da fonte',
        fontSizes: {
          normal: 'Normal',
          large: 'Grande',
          xlarge: 'Extra Grande'
        },
        saveChanges: 'Salvar Alterações'
      },
      home: {
        title: 'Aplicativo de Teste DMV',
        subtitle: 'Seu melhor recurso para estudar e praticar para o exame teórico do DMV. Escolha um teste abaixo para começar!',
        startQuiz: 'Iniciar Teste',
        state: 'Estado',
        availableQuizzes: 'Testes disponíveis'
      }
    }
  }
};

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
    }
  });

export default i18next;
